import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { AppContext } from "~/scripts/context/app";

class Social extends Component {
    static propTypes = {
        facebook: PropTypes.string,
        instagram: PropTypes.string,
        position: PropTypes.oneOf(["left", "right"]).isRequired
    };

    static contextType = AppContext;

    renderSocialLink = (text, link) =>
        !link ? null : (
            <a
                className="social__link"
                href={link}
                target="_blank"
                rel="noopener noreferrer"
            >
                {text}
            </a>
        );

    render() {
        const { facebook, instagram, position } = this.props;
        const { theme } = this.context;

        if (!facebook && !instagram) {
            return null;
        }

        return (
            <div className={classNames("social", `theme-${theme}`)}>
                <div className={"social__inner " + position}>
                    {this.renderSocialLink("Facebook", facebook)}
                    {this.renderSocialLink("Instagram", instagram)}
                </div>
            </div>
        );
    }
}

export default Social;



// WEBPACK FOOTER //
// ./src/scripts/components/Social.js